import { __extends } from "tslib";
import { GetApnsVoipSandboxChannelRequest, GetApnsVoipSandboxChannelResponse } from "../models/index";
import { deserializeAws_restJson1GetApnsVoipSandboxChannelCommand, serializeAws_restJson1GetApnsVoipSandboxChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetApnsVoipSandboxChannelCommand = /** @class */ (function (_super) {
    __extends(GetApnsVoipSandboxChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetApnsVoipSandboxChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetApnsVoipSandboxChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetApnsVoipSandboxChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetApnsVoipSandboxChannelResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetApnsVoipSandboxChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetApnsVoipSandboxChannelCommand(input, context);
    };
    GetApnsVoipSandboxChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetApnsVoipSandboxChannelCommand(output, context);
    };
    return GetApnsVoipSandboxChannelCommand;
}($Command));
export { GetApnsVoipSandboxChannelCommand };
//# sourceMappingURL=GetApnsVoipSandboxChannelCommand.js.map